<template>
  <BaseDialog
    title="Выберите шаблон отчета"
    :dialog="dialog"
    :save-btn-loading="dataLoaded"
    title-for-confirm="Скачать"
    @close="closeModal"
    @save="downloadFormTemplateExcel"
  >
    <v-autocomplete
      v-model="selectedReport"
      no-data-text="Список пуст"
      outlined dense no-filter hide-no-data
      :items="reportTemplatesList"
      item-value="id"
      item-text="name"
      label="Шаблон"
      placeholder="Выберите шаблон"
      hide-details
      @input="isReport = !selectedReport"
    />

    <v-checkbox
      v-model="isReport"
      label="Без шаблона"
      hide-details
      @change="isReport && (selectedReport = null)"
    />
  </BaseDialog>
</template>

<script>
import BaseDialog from '@/ui/dialog/BaseDialog'
import { excelApi, reportFieldSetApi } from '@/api'
import download from '@/plugins/download'

export default {
  name: 'ChoosingReportTemplatesListForDownloadDialog',

  components: { BaseDialog },

  props: {
    dialog: Boolean,
    selectedItem: {
      type: Object,
      default: null,
    },
  },

  data: () => ({
    dataLoaded: false,
    reportTemplatesList: [],
    selectedReport: null,
    isReport: true,
  }),

  methods: {
    async getReportTemplatesList() {
      try {
        this.reportTemplatesList = await reportFieldSetApi.getAllReportFieldsByFormTemplateId(this.selectedItem.id)
      } catch (e) {
        console.log(e)
      }
    },

    async downloadFormTemplateExcel() {
      try {
        this.dataLoaded = true
        const data = await excelApi.downloadFormTemplateExcel(this.selectedItem.id, this.selectedReport)

        download(data, `Отчет формы (${this.selectedItem.name}).xlsx`)
        this.closeModal()
      } catch (e) {
        this.showErrorMessage(e, 'Ошибка загрузки')
      } finally {
        this.dataLoaded = false
      }
    },

    closeModal() {
      this.selectedReport = null
      this.isReport = true
      this.$emit('closeModal')
    },
  },

  watch: {
    selectedItem: {
      immediate: true,
      deep: true,
      async handler() {
        if (this.selectedItem?.id) {
          await this.getReportTemplatesList()
        }
      },
    },
  },
}
</script>
